<h2 mat-dialog-title>
  {{ this.previewData.template.title }}
</h2>
<mat-dialog-content class="preview-container">
  <email-editor-preview [html]="renderedHtml$ | async" [loadingIndicator]="isRendering"></email-editor-preview>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="cancel()">{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
  <button mat-raised-button color="primary" (click)="closeWithAction()">{{ this.primaryActionText }}</button>
</mat-dialog-actions>
